import { useNavigate } from 'react-router-dom';
import { UpdatePwdForm } from '../../components/UpdatePwdForm/UpdatePwdForm';

const UpdatePwd = () => {
  const navigate = useNavigate();
  return <UpdatePwdForm onSuccess={() => navigate(-1)} checkWrongPassword />;
};

export default UpdatePwd;
